import { Close as CloseIcon } from "@mui/icons-material";
import { Box, Dialog, DialogContent, IconButton, Stack, Typography } from "@mui/material";

import CheckCircle from "@/Components/Icons/CheckCircle";

interface UnlockMaiteModalProps {
  open: boolean;
  onClose: () => void;
}

export const UnlockMaiteModal: React.FC<UnlockMaiteModalProps> = ({ open, onClose }) => {
  const features = [
    "Unlimited MAITE queries per month",
    "Power Play experiments to boost Marketing ROI",
    "Instant Insights on your GrowthOS dashboards",
    "First access to exciting new AI-driven features",
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "24px",
        },
      }}
    >
      <DialogContent sx={{ px: 4, py: 6 }}>
        {/* Close button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Stack spacing={2}>
          {/* Title */}
          <Typography variant="h6" component="h6" fontWeight="600">
            The growth consultant in your pocket
          </Typography>

          {/* Subtitle */}
          <Typography variant="body2" mt={0}>
            The MMM of the future doesn&apos;t need you to be a data scientist. It just needs you to
            be curious.
          </Typography>

          {/* Feature list section */}
          <Box>
            <Box
              sx={{
                background: "#0E2244",
                borderRadius: 2,
                p: 3,
              }}
            >
              <Typography variant="body2" fontWeight="600" sx={{ color: "white", mb: 2 }}>
                Unlock MAITE today to access:
              </Typography>
              <Stack spacing={2}>
                {features.map((feature, index) => (
                  <Stack key={index} direction="row" spacing={2} alignItems="center">
                    <CheckCircle />
                    <Typography
                      variant="body1"
                      sx={{
                        color: "white",
                        fontSize: "1rem",
                        lineHeight: 1.5,
                      }}
                    >
                      {feature}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Box>
          </Box>

          {/* Call to action */}
          <Typography variant="body1">
            For more information, contact your Marketing Science Partner.
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
